
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medlem/[[...slug]]",
      function () {
        return require("private-next-pages/medlem/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medlem/[[...slug]]"])
      });
    }
  